import React, { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFormik } from 'formik';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Logo from '../../../components/Logo';
import useDarkMode from '../../../hooks/useDarkMode';
import Spinner from '../../../components/bootstrap/Spinner';
import { auth, checkEmail } from '../../../_services/user';
import { userAtom } from '../../../_atoms/user';
import { dashboardPagesMenu } from '../../../menu';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import { useTranslation } from 'react-i18next';
import { getLangWithKey } from '../../../lang';
import RegisterCompany from './RegisterCompany';
import { createRequest, validateRequest } from '../../../_services/request';



const Login = ({ isSignUp }) => {
	const [user, setUser] = useAtom(userAtom)
	const [userData, setUserData] = useState({ firstname: "", familyname: "", email: "" })
	const [codeSend, setCodeSend] = useState(false)
	const { darkModeStatus } = useDarkMode();

	const [signInPassword, setSignInPassword] = useState(false);
	const [singUpStatus, setSingUpStatus] = useState(!!isSignUp);
	const [isLoading, setIsLoading] = useState(false);

	const { t } = useTranslation()

	const navigate = useNavigate();


	const LoginHeader = ({ isNewUser }) => {
		if (isNewUser) {
			return (
				<>
					<div className='text-center h1 fw-bold mt-5'>{t("login.createTitle")}</div>
					<div className='text-center h4 text-muted mb-5'>{t("login.createText")}</div>
				</>
			);
		}
		return (
			<>
				<div className='text-center h1 fw-bold mt-5'>{t("login.welcome")}</div>
				<div className='text-center h4 text-muted mb-5'>{t("login.loginText")}</div>
			</>
		);
	};
	LoginHeader.defaultProps = {
		isNewUser: false,
	};

	useEffect(() => {
		if (user.loggedIn) {
			navigate(`../${dashboardPagesMenu.dashboard.path}`);
		}
		return () => { };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: "",
			password: "",
		},
		validate: (values) => {
			const errors = {};

			if (!values.email) {
				errors.email = t("common.notEmpty");
			}

			if (!values.password) {
				errors.password = t("common.notEmpty");
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			setIsLoading(true)
			const data = { email: userData.email, password: values.password }
			auth(data)
				.then(res => {
					setIsLoading(false)
					if (res.data && res.data.code === 200) {
						setUser({ loggedIn: true, ...res.data.data, token: res.data.token })
						document.cookie = `token=${res.data.token};path=/`
					} else {
						formik.setFieldError('password', t("login.passwordNotCorrect"));
					}
				})
				.catch(err => {
					setIsLoading(false)
					formik.setFieldError('password', t("common.error"));
				})
		},
	});

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const formik3 = useFormik({
		enableReinitialize: true,
		initialValues: {
			firstname: "",
			familyname: "",
			email: "",
			companyName: "",
		},
		validate: (values) => {
			const errors = {};

			if (!values.firstname || !values.familyname || !values.email || !values.companyName) {
				errors.email = t("common.notEmpty");
				errors.firstname = t("common.notEmpty");
				errors.familyname = t("common.notEmpty");
				errors.companyName = t("common.enterCompanyName");
			}
			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			setIsLoading(true)
			const data = { email: values.email, firstname: values.firstname, familyname: values.familyname, companyName: values.companyName }
			createRequest(data)
				.then(res => {
					setIsLoading(false)
					if (res.data && res.data.code === 200) {
						setCodeSend(true)
						formik4.setFieldValue("firstname", values.firstname)
						formik4.setFieldValue("familyname", values.familyname)
						formik4.setFieldValue("email", values.email)
						formik4.setFieldValue("companyName", values.companyName)

						formik3.setFieldValue("firstname", "")
						formik3.setFieldValue("familyname", "")
						formik3.setFieldValue("email", "")
						formik3.setFieldValue("companyName", "")
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.success")}</span>
							</span>,
							t("login.createSuccess"),
						);
					} else {
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.error")}</span>
							</span>,
							t("serverErrors." + res.data.errorCode),
						);
					}
				})
				.catch(err => {
					setIsLoading(false)
					showNotification(
						<span className='d-flex align-items-center'>
							<Icon icon='Info' size='lg' className='me-1' />
							<span>{t("common.failure")}</span>
						</span>,
						t("common.error"),
					);
				})
		}
	})

	const formik4 = useFormik({
		enableReinitialize: true,
		initialValues: {
			code: "",
			password: "",
			passwordRepeat: "",
			firstname: "",
			familyname: "",
			email: "",
			companyName: "",
		},
		validate: (values) => {
			const errors = {};

			if (!values.code) {
				errors.code = t("common.notEmpty");
			}

			if (values.password.length < 6) {
				errors.password = t("common.passwordLengthError");
			}

			if (values.password !== values.passwordRepeat) {
				errors.password = t("common.passwordsUnmatch");
				errors.passwordRepeat = t("common.passwordsUnmatch");
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			setIsLoading(true)
			const data = { code: values.code, password: values.password, email: values.email, companyName: values.companyName, firstname: values.firstname, familyname: values.familyname }
			validateRequest(data)
				.then(res => {
					console.log(data, res.data)
					setIsLoading(false)
					if (res.data && res.data.code === 200) {
						formik4.setFieldValue("firstname", "")
						formik4.setFieldValue("familyname", "")
						formik4.setFieldValue("email", "")
						formik4.setFieldValue("companyName", "")
						setSingUpStatus(!singUpStatus)
						setUser({ loggedIn: true, ...res.data.data, token: res.data.token })
						document.cookie = `token=${res.data.token};path=/`
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.success")}</span>
							</span>,
							t("login.validateSuccess"),
						);
						setCodeSend(false)
					} else {
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.error")}</span>
							</span>,
							t("serverErrors." + res.data.errorCode),
						);
					}
				})
				.catch(err => {
					setIsLoading(false)
					showNotification(
						<span className='d-flex align-items-center'>
							<Icon icon='Info' size='lg' className='me-1' />
							<span>{t("common.failure")}</span>
						</span>,
						t("common.error"),
					);
				})
		}
	})

	const handleContinue = () => {
		setIsLoading(true);
		const data = { email: formik.values.email }
		checkEmail(data)
			.then(res => {
				setIsLoading(false);
				if (res.data && res.data.code === 200) {
					if (res.data.data && res.data.data._id) {
						setUserData(res.data.data)
						setSignInPassword(true);
					} else {
						formik.setFieldError('email', t("login.emailFailure"));
					}
				} else {
					formik.setFieldError('email', t("common.error"));
				}
			})
			.catch(err => {
				formik.setFieldError('email', t("common.error"));
			})
	};

	const { i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng).then();
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{t("common.langTitle", { lang: getLangWithKey(lng)?.text })}</span>
			</span>,
			t("common.langText"),
		);
	};

	return (
		<PageWrapper
			isProtected={false}
			title={singUpStatus ? t("common.signUp") : t("common.login")}
			className={classNames({ 'bg-dark': !singUpStatus, 'bg-light': singUpStatus })}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='login-page'>
							{/* <div className='col-auto justify-center' style={{ position: "absolute", right: 10, top: 10 }}>
								<Dropdown>
									<DropdownToggle hasIcon={false}>
										{typeof getLangWithKey(i18n.language)?.icon ===
											'undefined' ? (
											<Button
												// eslint-disable-next-line react/jsx-props-no-spreading
												{...styledBtn}
												className='btn-only-icon'
												aria-label='Change language'
												data-tour='lang-selector'>
												<Spinner isSmall inButton='onlyIcon' isGrow />
											</Button>
										) : (
											<Button
												// eslint-disable-next-line react/jsx-props-no-spreading
												{...styledBtn}
												icon={
													getLangWithKey(i18n.language)?.icon
												}
												aria-label='Change language'
												data-tour='lang-selector'
											/>
										)}
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
										{Object.keys(LANG).map((i) => (
											<DropdownItem key={LANG[i].lng}>
												<Button
													icon={LANG[i].icon}
													onClick={() => changeLanguage(LANG[i].lng)}>
													{LANG[i].text}
												</Button>
											</DropdownItem>
										))}
									</DropdownMenu>
								</Dropdown>
							</div> */}
							<CardBody>
								<div className='text-center my-5'>
									<Link
										to='https://oxysuite.com'
										target='_blank'
										className={classNames(
											'text-decoration-none  fw-bold display-2',
											{
												'text-dark': !darkModeStatus,
												'text-light': darkModeStatus,
											},
										)}
										aria-label='Facit'>
										<Logo width={200} height={60} />
									</Link>
								</div>
								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-dark': darkModeStatus,
									})}>
									<div className='row row-cols-2 g-3 pb-3 px-3 mt-0'>
										<div className='col'>
											<Button
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={singUpStatus}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setSignInPassword(false);
													setSingUpStatus(!singUpStatus);
												}}>
												{t("common.login")}
											</Button>
										</div>
										<div className='col'>
											<Button
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={!singUpStatus}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setSignInPassword(false);
													setSingUpStatus(!singUpStatus);
												}}>
												{t("common.signUp")}
											</Button>
										</div>
									</div>
								</div>
								<LoginHeader isNewUser={singUpStatus} />
								<form className='row g-4'>
									{singUpStatus ? (
										<RegisterCompany formik={formik3} formik2={formik4} signInPassword={signInPassword} codeSend={codeSend} setCodeSend={setCodeSend} />
									) : (
										<>
											<div className='col-12'>
												<FormGroup
													id='email'
													isFloating
													label={t("common.email")}
													className={classNames({
														'd-none': signInPassword,
													})}>
													<Input
														autoComplete='username'
														value={formik.values.email}
														isTouched={formik.touched.email}
														invalidFeedback={
															formik.errors.email
														}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
												{signInPassword && (
													<div className='text-center h4 mb-3 fw-bold'>
														{t("common.greeting", { firstname: userData.firstname, familyname: userData.familyname })}
													</div>
												)}
												<FormGroup
													id='password'
													isFloating
													label={t("common.password")}
													className={classNames({
														'd-none': !signInPassword,
													})}>
													<Input
														type='password'
														autoComplete='current-password'
														value={formik.values.password}
														isTouched={formik.touched.password}
														invalidFeedback={
															formik.errors.password
														}
														validFeedback='Looks good!'
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
													/>
												</FormGroup>
											</div>
											<div className='col-12'>
												{!signInPassword ? (
													<Button
														color='warning'
														className='w-100 py-3'
														isDisable={!formik.values.email}
														onClick={handleContinue}>
														{isLoading && (
															<Spinner isSmall inButton isGrow />
														)}
														{t("common.continue")}
													</Button>
												) : (
													<Button
														color='warning'
														className='w-100 py-3'
														onClick={formik.handleSubmit}>
														{t("common.login")}
													</Button>
												)}
											</div>
										</>
									)}
								</form>
							</CardBody>
						</Card>
						<div className='text-center'>
							<a
								href='/'
								className={classNames('text-decoration-none me-3', {
									'link-light': singUpStatus,
									'link-dark': !singUpStatus,
								})}>
								Privacy policy
							</a>
							<a
								href='/'
								className={classNames('link-light text-decoration-none', {
									'link-light': singUpStatus,
									'link-dark': !singUpStatus,
								})}>
								Terms of use
							</a>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
Login.propTypes = {
	isSignUp: PropTypes.bool,
};
Login.defaultProps = {
	isSignUp: false,
};

export default Login;
